import axios from "axios";

const instance = axios.create({
  headers: {
    "Content-Type": "application/json",
    "Accept": "*/*",
  },
  timeout: 180000,
});

instance.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem("jwt");
    if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}`;
    }
    // If the request data is FormData, let the browser set Content-Type including boundary
    try {
      if (config && config.data && config.data instanceof FormData) {
        if (config.headers && config.headers['Content-Type']) {
          delete config.headers['Content-Type'];
        }
      }
    } catch (e) {
      // ignore
    }
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);
export default instance;
